import registerGlobalContext from '@plasmicapp/host/registerGlobalContext';
import React from 'react';

function EmbedCss(_ref) {
  var css = _ref.css,
    children = _ref.children;
  if (!css) {
    return React.createElement(React.Fragment, null, children);
  }
  return React.createElement(React.Fragment, null, React.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: css
    }
  }), " ", children);
}
var embedCssMeta = {
  name: "global-embed-css",
  displayName: "Embed Css",
  importName: "EmbedCss",
  importPath: "@plasmicpkgs/plasmic-embed-css",
  props: {
    css: {
      type: "code",
      lang: "css",
      defaultValueHint: "/* CSS snippet */",
      description: "CSS rules to be inserted"
    }
  }
};
function registerEmbedCss(loader, customEmbedCssMeta) {
  if (loader) {
    loader.registerGlobalContext(EmbedCss, customEmbedCssMeta != null ? customEmbedCssMeta : embedCssMeta);
  } else {
    registerGlobalContext(EmbedCss, customEmbedCssMeta != null ? customEmbedCssMeta : embedCssMeta);
  }
}

export { EmbedCss, embedCssMeta, registerEmbedCss };
//# sourceMappingURL=plasmic-embed-css.esm.js.map
